export default __webpack_public_path__ + "static/media/12-small.d22e61cc.png";